<form
  [formGroup]="form"
  (submit)="sendPaylinkData()"
  class="add-link">
  <h2 class="headline">
    {{ "PAYMENT_LINK_PAGE.MODAL_ADD.TITLE" | translate }}
  </h2>
  <div class="scroll-block">
    <div class="add-link__line">
      <div class="input-line">
        <div
          [class.error]="form.get('name')?.invalid && form.get('name')?.touched"
          class="input-block">
          <input
            formControlName="name"
            id="name"
            class="input"
            type="text"
            placeholder=" " />
          <label
            for="name"
            class="placeholder">
            {{ "PAYMENT_LINK_PAGE.MODAL_ADD.NAME" | translate }}*
          </label>
          <ng-container *ngIf="form.get('name')?.invalid && form.get('name')?.touched">
            <span
              *ngIf="nameRequiredError"
              class="input-block__error">
              {{ "PAYMENT_LINK_PAGE.ERROR.NAME_REQUIRED" | translate }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="add-link__line">
      <div class="add-link__line-left">
        <div class="input-line">
          <div
            [class.error]="form.get('sum')?.invalid && form.get('sum')?.touched"
            class="input-block">
            <input
              formControlName="sum"
              id="sum"
              inputmode="numeric"
              mask="separator.2"
              maxlength="10"
              class="input"
              type="text"
              placeholder=" " />
            <label
              for="sum"
              class="placeholder">
              {{ "PAYMENT_LINK_PAGE.MODAL_ADD.SUM" | translate }}*
            </label>
            <ng-container *ngIf="form.get('sum')?.invalid && form.get('sum')?.touched">
              <span
                *ngIf="sumRequiredError"
                class="input-block__error">
                {{ "PAYMENT_LINK_PAGE.ERROR.SUM_REQUIRED" | translate }}
              </span>
            </ng-container>
          </div>
        </div>
        <div class="currency">
          {{ selectedCurrency?.currency }}
        </div>
      </div>
      <div class="add-link__line-right">
        <div class="input-line">
          <app-form-custom-search
            formControlName="paymentType"
            [itemList]="paymentTypeList"
            [errorText]="paymentTypeError"
            (searchEvent)="searchEvent($event)"
            title="{{ 'PAYMENT_LINK_PAGE.MODAL_ADD.PAYMENT_TYPE_NAME' | translate }}*">
          </app-form-custom-search>
        </div>
      </div>
    </div>
    <div class="add-link__line select">
      <div class="add-link__line-left">
        <app-form-custom-select
          [itemList]="paylinkTypesList"
          [errorText]="typeError"
          formControlName="type"
          title="{{ 'PAYMENT_LINK_PAGE.MODAL_ADD.PAYMENT_TYPE' | translate }}">
        </app-form-custom-select>
      </div>
      <div class="add-link__line-right">
        <app-form-custom-select
          [itemList]="virtualPosList"
          [errorText]="posError"
          (onChanges)="setCurrency($event)"
          formControlName="pos"
          title="{{ 'PAYMENT_LINK_PAGE.MODAL_ADD.VIRTUAL_POS' | translate }}">
        </app-form-custom-select>
      </div>
    </div>
    <div class="add-link__line">
      <div class="add-link__line-left">
        <div class="input-line">
          <div
            [class.error]="form.get('orderNumber')?.invalid && form.get('orderNumber')?.touched"
            class="input-block">
            <input
              formControlName="orderNumber"
              id="orderNumber"
              class="input"
              type="text"
              placeholder=" " />
            <label
              for="orderNumber"
              class="placeholder">
              {{ "PAYMENT_LINK_PAGE.MODAL_ADD.ORDER_NUMBER" | translate }}
            </label>
          </div>
        </div>
      </div>
      <div class="add-link__line-right">
        <div class="input-line">
          <div
            [class.error]="form.get('fullName')?.invalid && form.get('fullName')?.touched"
            class="input-block">
            <input
              formControlName="fullName"
              id="fullName"
              class="input"
              type="text"
              placeholder=" " />
            <label
              for="fullName"
              class="placeholder">
              {{ "PAYMENT_LINK_PAGE.MODAL_ADD.FULL_NAME" | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="add-link__line select">
      <div class="add-link__line-left">
        <div class="input-line">
          <app-form-custom-datepicker
            [horizontalPosition]="'semi-top'"
            [verticalPosition]="verticalPosition"
            [isFull]="true"
            [errorText]="dateFromError"
            formControlName="dateFrom"
            title="{{ 'PAYMENT_LINK_PAGE.MODAL_ADD.DATE_START' | translate }}">
          </app-form-custom-datepicker>
        </div>
      </div>
      <div class="add-link__line-right">
        <div class="input-line">
          <app-form-custom-datepicker
            [horizontalPosition]="'semi-top'"
            [verticalPosition]="'right'"
            [isFull]="true"
            formControlName="dateTo"
            title="{{ 'PAYMENT_LINK_PAGE.MODAL_ADD.DATE_END' | translate }}">
          </app-form-custom-datepicker>
        </div>
      </div>
    </div>
    <div class="edit-link__line">
      <div class="input-line">
        <div
          [class.error]="form.get('webhook_url')?.invalid && form.get('webhook_url')?.touched"
          class="input-block">
          <input
            formControlName="webhook_url"
            id="webhook_url"
            class="input"
            type="text"
            placeholder=" " />
          <label
            for="webhook_url"
            class="placeholder">
            {{ "PAYMENT_LINK_PAGE.MODAL_ADD.WEBHOOK_URL" | translate }}
          </label>
        </div>
      </div>
    </div>
    <div
      *appHasAccess="['LINKS_SEND']"
      formArrayName="emailFields"
      class="add-link__line mail">
      <div
        *ngFor="let emailForm of emailFields.controls; let i = index"
        class="input-line mail-input">
        <div
          [formGroup]="getFormGroup(emailForm)"
          [class.error]="form.get('email')?.invalid && form.get('email')?.touched"
          class="input-block">
          <input
            formControlName="email"
            id="{{ 'email' + i }}"
            class="input"
            type="email"
            placeholder=" " />

          <button
            (click)="deleteEmailField(i)"
            *ngIf="!emailForm.value.email || (emailForm.invalid && emailForm.touched)"
            type="button"
            class="delete-mail">
            <img
              src="assets/img/delete.svg"
              alt="" />
          </button>
          <label
            for="{{ 'email' + i }}"
            class="placeholder">
            {{ "PAYMENT_LINK_PAGE.MODAL_ADD.EMAIL" | translate }}
          </label>
          <ng-container *ngIf="emailForm.get('email')?.status === 'INVALID' && emailForm.get('email')?.touched">
            <span class="input-block__error">
              {{ "PAYMENT_LINK_PAGE.ERROR.MAIL_REQUIRED" | translate }}
            </span>
          </ng-container>
        </div>
      </div>
    </div>
    <button
      *ngIf="emailFields.controls.length !== 0 && emailFields.controls.length < 4"
      [disabled]="emailFields.invalid"
      (click)="addEmailFields()"
      class="btn btn-link add-mail">
      {{ "PAYMENT_LINK_PAGE.MODAL_ADD.ADD_EMAIL" | translate }}
    </button>
    <div
      *appHasAccess="['LINKS_SEND']"
      class="add-link__line checkbox">
      <app-checkbox-item
        [item]="checkboxEmail"
        (changeItem)="changeEmailCheck($event)">
      </app-checkbox-item>
    </div>
    <div class="add-link__line checkbox">
      <app-checkbox-item [item]="checkboxActiveLink"></app-checkbox-item>
    </div>
    <div class="add-link__line checkbox">
      <app-checkbox-item [item]="checkboxOnce"></app-checkbox-item>
    </div>
  </div>

  <div class="btn-block">
    <button
      [disabled]="form.invalid || isSending"
      type="submit"
      class="btn btn-accent">
      {{ "PAYMENT_LINK_PAGE.MODAL_ADD.SAVE" | translate }}
    </button>
    <button
      (click)="closeModal()"
      type="button"
      class="btn btn-light">
      {{ "PAYMENT_LINK_PAGE.MODAL_ADD.CANCEL" | translate }}
    </button>
  </div>
</form>
